import { connect } from 'react-redux';
import { IState } from '../../../../store/types';
import { findLanguageById, getAudioById, getLanguages } from '../../../../store/models/selectors';
import { CONFERENCE_PROVIDERS } from '../../../../../common/constants';
import { ConferenceSettings } from '../components/ConferenceSettings';
import { IConferenceSettingsEvents, IConferenceSettingsFields } from '../components/types';
import { IConferenceSettingsHOCProps } from './types';
import { ConferenceSettingsEvents } from './events';
import { getCallLangOptions } from '../../selectors/getCallLangOptions';
import { getAuthUser } from '../../../../store/general/selectors';
import { EAuthUserRole } from '../../../../store/general/types';

const mapStateToProps = (
	state: IState,
	{ audioId, isProcessing, log, logStatus, logTime, section }: IConferenceSettingsHOCProps
): IConferenceSettingsFields => {
	const audio = audioId != null ? getAudioById(state, audioId) : undefined;
	// Backend stores the language as langId; resolve to a code for the picker (fall back to the audio's language).
	const langCode = (audio?.langId != null ? findLanguageById(state, audio.langId)?.code : undefined)
		|| audio?.language?.code || '';
	const isAdmin = getAuthUser(state)?.role === EAuthUserRole.ADMIN;

	return {
		title: audio?.title || '',
		description: audio?.description || '',
		langCode,
		multilingual: audio?.multilingual ?? false,
		provider: audio?.transcriptionProvider || CONFERENCE_PROVIDERS[0],
		saveLevel: audio?.saveLevel ?? 'video',
		langs: getLanguages(state),
		options: getCallLangOptions(state),
		providers: CONFERENCE_PROVIDERS,
		isProcessing,
		isConfOwner: isAdmin || audio?.isConfOwner,
		isAdmin,
		keptExisting: audio?.progress?.keptExisting ?? false,
		log,
		logStatus,
		logTime,
		section,
	};
};

const mapDispatchToProps = (
	dispatch: any,
	{ audioId, onProcess }: IConferenceSettingsHOCProps
): IConferenceSettingsEvents => ({
	onChange: (settings) => dispatch(ConferenceSettingsEvents.onChange(audioId || 0, settings)),
	onInfoChange: (info) => dispatch(ConferenceSettingsEvents.onInfoChange(audioId || 0, info)),
	onGenerateInfo: (first) => dispatch(ConferenceSettingsEvents.onGenerateInfo(audioId || 0, first)),
	onRestoreInfo: () => dispatch(ConferenceSettingsEvents.onRestoreInfo(audioId || 0)),
	onProcess,
});

export const ConferenceSettingsHOC = connect(
	mapStateToProps,
	mapDispatchToProps
)(ConferenceSettings);

ConferenceSettingsHOC.displayName = 'ConferenceSettingsHOC';
